import { render, staticRenderFns } from "./TheThgUnauthenticatedList.vue?vue&type=template&id=47fb51a8&scoped=true"
import script from "./TheThgUnauthenticatedList.vue?vue&type=script&lang=ts"
export * from "./TheThgUnauthenticatedList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fb51a8",
  null
  
)

export default component.exports